<template>
	<div class="ViewStoreList">
		<div class="title text-lg text-dark-grey">
			Store List
		</div>
		<div class="store-list">
			<div
				v-for="(item, index) in displayStores"
				:key="index"
				class="store text-base"
			>
				<span class="store-name text-xs">
					{{ item.account_info && item.account_info.name }}
				</span>
				<span
					class="cursor-pointer"
					@click="locations.splice(locations.indexOf(item.id), 1)"
					><i class="el-icon-close"
				/></span>
			</div>
		</div>
		<div class="add-store my-2">
			<label class="text-base">
				Add Stores
			</label>
			<div>
				<el-select
					v-model="locations"
					multiple
					collapse-tags
					style="max-width: 320px;"
					placeholder="Select Stores"
				>
					<el-option
						v-for="(store, storeIndex) in stores"
						:key="storeIndex"
						:label="store.name"
						:value="store.id"
					/>
				</el-select>
			</div>
			<div class="my-4 w-40">
				<BaseButton
					type="submit"
					buttonclass="btn p-2.5 text-sm"
					@click="$emit('editSuppliedStores', locations)"
				>
					Save
				</BaseButton>
			</div>
		</div>
	</div>
</template>

<script>
// import { SuppliersMixin } from "../../../../.././../../mixins/suppliers.mixin";
export default {
	name: "ViewStoreList",
	props: {
		stores: {
			type: Array,
			required: true
		},
		locations: {
			type: Array,
			required: true
		}
	},
	data() {
		return {
			outletsSelected: "value",
			store: [],
			users: []
		};
	},
	computed: {
		displayStores() {
			return this.locations.map(location => {
				return {
					id: location,
					account_info: this.stores.find(store => {
						if (store.id === location) return true;
					})
				};
			});
		}
	}
};
</script>

<style lang="scss" scoped>
@import "./ViewStoreList.scss";
</style>
